export function getDadosEnviar (dadosForm) {
  const obj = dadosForm

  obj.obito = objetoObitoEnviar(obj)
  obj.registro = objetoRegistroEnviar(obj)

  obj.tipo_registro = obj.tipo_registro_obito || 'O'
  obj.registro.tipo_registro = obj.tipo_registro_obito || 'O'

  if (obj.enderecos) delete obj.enderecos // nao recebemos isso no back.

  delete obj.pessoa // pessoa vai no obj obj.registro.pessoa

  return obj
}

/**
 * Formata Objeto Obito
 */

function objetoObitoEnviar (dados) {

  const obito = {
    idade: dados.pessoa.idade,
    idade_tipo: dados.idade_tipo,
    numero_declaracao_obito: dados.numero_declaracao_obito,
    sem_declaracao_obito: dados.sem_declaracao_obito,
    tipo_morte: dados.causaObito && dados.causaObito.tipo_morte,
    causa_morte_parte_1_a: dados.causaObito && dados.causaObito.causa_morte_parte_1_a,
    causa_morte_parte_1_b: dados.causaObito && dados.causaObito.causa_morte_parte_1_b,
    causa_morte_parte_1_c: dados.causaObito && dados.causaObito.causa_morte_parte_1_c,
    causa_morte_parte_1_d: dados.causaObito && dados.causaObito.causa_morte_parte_1_d,
    causa_morte_parte_2_a: dados.causaObito && dados.causaObito.causa_morte_parte_2_a,
    causa_morte_parte_2_b: dados.causaObito && dados.causaObito.causa_morte_parte_2_b,
    convenio_funeraria: dados.convenio_funeraria,
    numero_declaracao_funeraria: dados.numero_declaracao_funeraria,
    deixa_bens: dados.deixa_bens,
    deixa_testamento: dados.deixa_testamento,
    deixa_filhos: dados.deixa_filhos,
    reservista: dados.reservista,
    eleitor_ativo: dados.eleitor_ativo,
    funeraria: dados.funeraria,
    funeraria_id: dados.funeraria_id,
    sepultamento: dados.sepultamento,
    sepultamento_id: dados.sepultamento_id,
    pessoa_desconhecida: dados.pessoa_desconhecida,
    natimorto: dados.natimorto,
    semanas_gestacao: dados.semanas_gestacao,
    qtd_gemeos: dados.qtd_gemeos
  }

  return obito
}

function objetoRegistroEnviar (dadosForm) {
  const registro = {
    ...dadosForm.registro
  }

  registro.pessoa = objetoPessoaEnviar(dadosForm)

  return registro
}

/**
 * Formata o Objeto Pessoa
 */
function objetoPessoaEnviar (dadosForm) {
  const pessoa = {
    pessoa_id: dadosForm.pessoa.pessoa_id,
    cpf: dadosForm.pessoa.cpf,
    cpf_sem_inscricao: dadosForm.pessoa.cpf_sem_inscricao,
    nome: dadosForm.pessoa.nome.toUpperCase(),
    data_nascimento: dadosForm.pessoa.data_nascimento,
    sexo: dadosForm.pessoa.sexo,
    cor_pele: dadosForm.pessoa.cor_pele ? dadosForm.pessoa.cor_pele.toUpperCase() : null,
    estado_civil: dadosForm.pessoa.estado_civil ? dadosForm.pessoa.estado_civil.toUpperCase().replace(' ', '_') : null,
    ocupacao_declarada: dadosForm.pessoa.ocupacao_declarada,
    ocupacao_codigo: dadosForm.pessoa.ocupacao_codigo,
    nacionalidade_codigo: dadosForm.pessoa.nacionalidade_codigo,
    uf: dadosForm.pessoa.uf || null,
    naturalidade: dadosForm.pessoa.naturalidade || null,
    naturalidade_declarada: dadosForm.pessoa.naturalidade_declarada || null,
    falecido: true,
    genitores: dadosForm.pessoa.genitores,
    documentos: [ ...dadosForm.pessoa.documentos ],
    endereco: dadosForm.pessoa.endereco,
    ultimo_convivente: dadosForm.pessoa.ultimo_convivente
  }

  return pessoa
}
